import React from 'react';
import { useNavigate } from 'react-router';
import classes from './summerCampSection.module.css';
import { getImageUrl } from '../../../utils/imageUrl';

const SummerCampSection = (props) => {
    const navigate = useNavigate();
    const buttonClickedHandler = (plan) => {    
        // props.setShowForm(true);
        // props.setSelectedPlan(plan);
        // window.scrollTo({top:0,behavior:'smooth'})
        // navigate("/camps/" + props.camp.toLowerCase()+ "-camp")    
        navigate(plan.link);
    }
    console.log(props);
    let currency = "JD"; 

    const language = parseInt(localStorage.getItem('language'), 10);

    if (!isNaN(language) && language !== 1) {
        currency = "دينار";
        // valid_until = `صالحة حتى ${new Date(pricingPackage.label?.text).toLocaleDateString('ar-JD', {
        //             month: 'long', day: 'numeric'})}`;

    }
    return (
        <div className={classes.SummerCampSection} style={{ backgroundImage: `url(${getImageUrl(props.heroSection?.current_promotions?.[0]?.banner_image)})` }}>
            <div className={classes.SummerCampOffersContainer}>
                <ul className={classes.SummerCampOffers}>
                    {props.pricingPackages?.map((pricingPackage, i) =>
                        <li key={pricingPackage.id}>
                            <div className={classes.Duration}>{pricingPackage.name}</div>
                            {pricingPackage.label ? <div className={classes.AvailableDate}>{parseInt(localStorage.getItem('language')) === 1 ? `Valid until ${new Date(pricingPackage.early_bird_end_date).toLocaleDateString('en-US', {
                                month: 'long', day: 'numeric'})}` : `صالحة حتى ${new Date(pricingPackage.early_bird_end_date).toLocaleDateString('ar-JD', {
                    month: 'long', day: 'numeric'})}`}</div> : <div className={classes.UnAvailableDate} />}
                            <div className={classes.Discount}>{pricingPackage.discount_label}</div>
                            <div className={classes.PriceAfterDiscount}>{pricingPackage.discounted_price} {currency}</div>
                            <div className={classes.PriceBeforeDiscount}> {pricingPackage.discount_percentage !== '0' ? `${pricingPackage.original_price} ${currency}` : ''}</div>
                            <button onClick={() => buttonClickedHandler(pricingPackage)}>
                                {parseInt(localStorage.getItem('language')) === 1 ? "GET NOW" : "احجز الآن"}
                            </button>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    )
}
export default SummerCampSection;